import { z } from 'zod';
import { uuidSchema, shortString, mediumString, positiveInt, nonNegativeInt, } from './validation.js';
/**
 * Transfer Order Schemas
 *
 * Shared validation schemas for transfer order operations.
 * Workflow: Draft -> In Transit -> Received -> Completed
 */
export const createTransferOrderSchema = z.object({
    sourceLocationId: uuidSchema,
    destinationLocationId: uuidSchema,
    notes: mediumString.optional(),
    description: mediumString.optional(),
    items: z.array(z.object({
        skuId: uuidSchema,
        orderedQuantity: positiveInt,
    })).min(1, 'At least one item required'),
});
export const getTransferOrdersSchema = z.object({
    locationId: uuidSchema.optional(),
});
export const updateTransferStatusSchema = z.object({
    transferId: uuidSchema,
    status: z.enum(['draft', 'in_transit', 'received', 'completed', 'deleted']),
});
export const processTransferItemSchema = z.object({
    itemId: uuidSchema,
    action: z.enum(['add_stock', 'edited', 'not_received']),
    receivedQuantity: nonNegativeInt,
    notes: mediumString.optional(),
    processedBy: shortString.min(1, 'Processor ID is required'),
});
export const reEditTransferItemSchema = z.object({
    itemId: uuidSchema,
    newReceivedQuantity: nonNegativeInt,
    notes: mediumString.optional(),
    processedBy: shortString.min(1, 'Processor ID is required'),
});
export const updateTransferDraftSchema = z.object({
    transferId: uuidSchema,
    sourceLocationId: uuidSchema.optional(),
    destinationLocationId: uuidSchema.optional(),
    notes: mediumString.nullable().optional(),
    description: mediumString.nullable().optional(),
    orderQuantities: z.record(z.string().uuid(), z.number().nonnegative()).optional(),
});
export const deleteTransferDraftSchema = z.object({
    transferId: uuidSchema,
});
